import React, { useCallback, useEffect } from 'react';
import { Icon, Toggle } from '@pwc/pwc-deals-ui';
import { useDispatch, useSelector } from 'react-redux';
import { getUserSettingsSelector } from 'common/redux/userSettings/userSettingsSlice';
import {
  changeUserPerformanceCookiePreferenceThunk,
  loadUserSettingsThunk,
} from 'common/redux/userSettings/userSettingsThunk';
import authorizationService from 'common/services/security/authorizationService';
import { getPendoServicePromise } from '../../../../../userAnalytics/helper';
import {
  getDoNotProcessRequest,
  removeFromStorage,
  toggleTableClass,
} from './performanceCookieHelpers';

export const PerformanceCookiesToggle = ({ policy }) => {
  const {
    loading,
    settings: { allowPerformanceCookies = true },
    loaded,
  } = useSelector(getUserSettingsSelector);
  const hasValidToken = authorizationService.hasValidToken();
  const dispatch = useDispatch();
  useEffect(() => {
    if (hasValidToken && !loaded && !loading) {
      dispatch(loadUserSettingsThunk());
    }
  }, [hasValidToken, dispatch, loaded, loading]);

  useEffect(() => {
    if (policy && !loading) {
      toggleTableClass(allowPerformanceCookies);
      if (!allowPerformanceCookies) {
        removeFromStorage(policy);
      }
    }
  }, [policy, loading, allowPerformanceCookies]);

  const userSettings = useSelector(getUserSettingsSelector);

  const handleToggle = useCallback(
    async (checked) => {
      if (authorizationService.hasValidToken() && userSettings.loaded) {
        if (checked) {
          await getPendoServicePromise();
        }
      }

      dispatch(
        changeUserPerformanceCookiePreferenceThunk(
          checked,
          getDoNotProcessRequest(checked)
        )
      );
    },
    [dispatch, userSettings]
  );

  return (
    <>
      <Toggle
        checked={allowPerformanceCookies}
        onClick={() => handleToggle(!allowPerformanceCookies)}
        name="performance-cookies-toggle"
        data-testid="performance-cookies-toggle"
        disabled={loading}
      >
        Accept cookies
      </Toggle>
      <div className="performance-cookies-toggle-info">
        <span>
          <Icon width={20} name="information" className="fill icon-yellow" />
        </span>
        <span>
          Please note that these cookies are required to enable the help and
          support functionality across the platform.
        </span>
      </div>
    </>
  );
};
